import axios from "@/api/axios";

function getManageOrganizationInfo(premiseId) {
  const params = {
    premiseId
  };
  return axios.get("services/v1.0/manageorganization/bypremise/", { params });
}

function getManageOrganizations(params) {
  return axios.get("services/v1.0/manageorganization/", { params });
}

function getCities(params) {
  return axios.get("geo/v1.0/locality/", { params });
}

function getStreets(params) {
  return axios.get("geo/v1.0/thoroughfare/", { params });
}

function getApartments(params) {
  return axios.get("geo/v1.0/premise/", { params });
}
export default {
  getManageOrganizationInfo,
  getManageOrganizations,
  getCities,
  getStreets,
  getApartments
};
